var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.006 3.753l-2.117-.003c-2.378 0-3.915 1.577-3.915 4.017V9.62H7.846a.333.333 0 00-.333.333v2.684c0 .184.15.333.333.333h2.128v6.77c0 .185.15.334.333.334h2.777c.184 0 .333-.15.333-.333v-6.771h2.488a.333.333 0 00.333-.333V9.952a.333.333 0 00-.332-.333h-2.49V8.05c0-.755.18-1.138 1.163-1.138h1.426c.184 0 .333-.15.333-.333V4.086a.333.333 0 00-.332-.333z","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"width":"24","height":"24"};

module.exports = Facebook;

Facebook.default = Facebook;
